export default __webpack_public_path__ + "static/tree_top-93a74b023df93d3dbac17b38a1b9cc27.png";